import { i18n } from 'i18n';

export const COUNTRIES: { [key: string]: string } = {
	AD: i18n.t('Андорра'),
	AE: i18n.t('ОАЭ'),
	AF: i18n.t('Афганистан'),
	AG: i18n.t('Антигуа и Барбуда'),
	AI: i18n.t('Антарктида'),
	AL: i18n.t('Албания'),
	AM: i18n.t('Армения'),
	AO: i18n.t('Ангола'),
	AR: i18n.t('Аргентина'),
	AS: i18n.t('Американское Самоа'),
	AT: i18n.t('Австрия'),
	AU: i18n.t('Австралия'),
	AW: i18n.t('Аруба'),
	AX: i18n.t('Аландские острова'),
	AZ: i18n.t('Азербайджан'),
	BA: i18n.t('Босния и Герцеговина'),
	BB: i18n.t('Барбадос'),
	BD: i18n.t('Бангладеш'),
	BE: i18n.t('Бельгия'),
	BF: i18n.t('Буркина-Фасо'),
	BG: i18n.t('Болгария'),
	BH: i18n.t('Бахрейн'),
	BI: i18n.t('Бурунди'),
	BJ: i18n.t('Бенин'),
	BL: i18n.t('Сен-Бартелеми'),
	BM: i18n.t('Бермудские острова'),
	BN: i18n.t('Бруней'),
	BO: i18n.t('Боливия'),
	BQ: i18n.t('Бонайре, Синт-Эстатиус и Саба'),
	BR: i18n.t('Бразилия'),
	BS: i18n.t('Багамские острова'),
	BT: i18n.t('Бутан'),
	BV: i18n.t('Остров Буве'),
	BW: i18n.t('Ботсвана'),
	BY: i18n.t('Беларусь'),
	BZ: i18n.t('Белиз'),
	CA: i18n.t('Канада'),
	CC: i18n.t('Кокосовые острова'),
	CD: i18n.t('Демократическая Республика Конго'),
	CF: i18n.t('Центральноафриканская Республика'),
	CG: i18n.t('Республика Конго'),
	CH: i18n.t('Швейцария'),
	CI: i18n.t('Кот-д’Ивуар'),
	CK: i18n.t('Острова Кука'),
	CL: i18n.t('Чили'),
	CM: i18n.t('Камерун'),
	CN: i18n.t('Китай'),
	CO: i18n.t('Колумбия'),
	CR: i18n.t('Коста-Рика'),
	CU: i18n.t('Куба'),
	CV: i18n.t('Кабо-Верде'),
	CW: i18n.t('Кюрасао'),
	CX: i18n.t('Остров Рождества'),
	CY: i18n.t('Кипр'),
	CZ: i18n.t('Чехия'),
	DE: i18n.t('Германия'),
	DJ: i18n.t('Джибути'),
	DK: i18n.t('Дания'),
	DM: i18n.t('Доминика'),
	DO: i18n.t('Доминиканская Республика'),
	DZ: i18n.t('Алжир'),
	EC: i18n.t('Эквадор'),
	EE: i18n.t('Эстония'),
	EG: i18n.t('Египет'),
	EH: i18n.t('Западная Сахара'),
	ER: i18n.t('Эритрея'),
	ES: i18n.t('Испания'),
	ET: i18n.t('Эфиопия'),
	FI: i18n.t('Финляндия'),
	FJ: i18n.t('Фиджи'),
	FK: i18n.t('Фолклендские острова (Мальвинские)'),
	FM: i18n.t('Микронезия, Федеративные Штаты'),
	FO: i18n.t('Фарерские острова'),
	FR: i18n.t('Франция'),
	GA: i18n.t('Габон'),
	GB: i18n.t('Великобритания'),
	GD: i18n.t('Гренада'),
	GE: i18n.t('Грузия'),
	GF: i18n.t('Французская Гвиана'),
	GG: i18n.t('Гернси'),
	GH: i18n.t('Гана'),
	GI: i18n.t('Гибралтар'),
	GL: i18n.t('Гренландия'),
	GM: i18n.t('Гамбия'),
	GN: i18n.t('Гвинея'),
	GP: i18n.t('Гваделупа'),
	GQ: i18n.t('Экваториальная Гвинея'),
	GR: i18n.t('Греция'),
	GS: i18n.t('Южная Георгия и южные Сандвичевы острова'),
	GT: i18n.t('Гватемала'),
	GU: i18n.t('Гуам'),
	GW: i18n.t('Гвинея-Бисау'),
	GY: i18n.t('Гайана'),
	HK: i18n.t('Гонконг'),
	HM: i18n.t('Остров Херд и острова Макдональд'),
	HN: i18n.t('Гондурас'),
	HR: i18n.t('Хорватия'),
	HT: i18n.t('Гаити'),
	HU: i18n.t('Венгрия'),
	ID: i18n.t('Индонезия'),
	IE: i18n.t('Ирландия'),
	IL: i18n.t('Израиль'),
	IM: i18n.t('Остров Мэн'),
	IN: i18n.t('Индия'),
	IO: i18n.t('Британская территория в Индийском океане'),
	IQ: i18n.t('Ирак'),
	IR: i18n.t('Иран'),
	IS: i18n.t('Исландия'),
	IT: i18n.t('Италия'),
	JE: i18n.t('Джерси'),
	JM: i18n.t('Ямайка'),
	JO: i18n.t('Иордания'),
	JP: i18n.t('Япония'),
	KE: i18n.t('Кения'),
	KG: i18n.t('Киргизия'),
	KH: i18n.t('Камбоджа'),
	KI: i18n.t('Кирибати'),
	KM: i18n.t('Коморы'),
	KN: i18n.t('Сент-Китс и Невис'),
	KP: i18n.t('КНДР'),
	KR: i18n.t('Южная Корея'),
	KW: i18n.t('Кувейт'),
	KY: i18n.t('Каймановы острова'),
	KZ: i18n.t('Казахстан'),
	LA: i18n.t('Лаос'),
	LB: i18n.t('Ливан'),
	LC: i18n.t('Сент-Люсия'),
	LI: i18n.t('Лихтенштейн'),
	LK: i18n.t('Шри-Ланка'),
	LR: i18n.t('Либерия'),
	LS: i18n.t('Лесото'),
	LT: i18n.t('Литва'),
	LU: i18n.t('Люксембург'),
	LV: i18n.t('Латвия'),
	LY: i18n.t('Ливия'),
	MA: i18n.t('Марокко'),
	MC: i18n.t('Монако'),
	MD: i18n.t('Молдова'),
	ME: i18n.t('Черногория'),
	MF: i18n.t('Сен-Мартен'),
	MG: i18n.t('Мадагаскар'),
	MH: i18n.t('Маршалловы острова'),
	MK: i18n.t('Северная Македония'),
	ML: i18n.t('Мали'),
	MM: i18n.t('Мьянма'),
	MN: i18n.t('Монголия'),
	MO: i18n.t('Макао'),
	MP: i18n.t('Северные Марианские острова'),
	MQ: i18n.t('Мартиника'),
	MR: i18n.t('Мавритания'),
	MS: i18n.t('Монсеррат'),
	MT: i18n.t('Мальта'),
	MU: i18n.t('Маврикий'),
	MV: i18n.t('Мальдивы'),
	MW: i18n.t('Малави'),
	MX: i18n.t('Мексика'),
	MY: i18n.t('Малайзия'),
	MZ: i18n.t('Мозамбик'),
	NA: i18n.t('Намибия'),
	NC: i18n.t('Новая Каледония'),
	NE: i18n.t('Нигер'),
	NF: i18n.t('Норфолк'),
	NG: i18n.t('Нигерия'),
	NI: i18n.t('Никарагуа'),
	NL: i18n.t('Нидерланды'),
	NO: i18n.t('Норвегия'),
	NP: i18n.t('Непал'),
	NR: i18n.t('Науру'),
	NU: i18n.t('Ниуэ'),
	NZ: i18n.t('Новая Зеландия'),
	OM: i18n.t('Оман'),
	PA: i18n.t('Панама'),
	PE: i18n.t('Перу'),
	PF: i18n.t('Французская Полинезия'),
	PG: i18n.t('Папуа Новая Гвинея'),
	PH: i18n.t('Филиппины'),
	PK: i18n.t('Пакистан'),
	PL: i18n.t('Польша'),
	PM: i18n.t('Сен-Пьер и Микелон'),
	PN: i18n.t('Питкэрн'),
	PR: i18n.t('Пуэрто-Рико'),
	PS: i18n.t('Палестина'),
	PT: i18n.t('Португалия'),
	PW: i18n.t('Палау'),
	PY: i18n.t('Парагвай'),
	QA: i18n.t('Катар'),
	RE: i18n.t('Реюньон'),
	RO: i18n.t('Румыния'),
	RS: i18n.t('Сербия'),
	RU: i18n.t('Россия'),
	RW: i18n.t('Руанда'),
	SA: i18n.t('Саудовская Аравия'),
	SB: i18n.t('Соломоновы острова'),
	SC: i18n.t('Сейшельские острова'),
	SD: i18n.t('Судан'),
	SE: i18n.t('Швеция'),
	SG: i18n.t('Сингапур'),
	SH: i18n.t('Острова Святой Елены, Вознесения и Тристан-да-Кунья'),
	SI: i18n.t('Словения'),
	SJ: i18n.t('Шпицберген и Ян Майен'),
	SK: i18n.t('Словакия'),
	SL: i18n.t('Сьерра-Леоне'),
	SM: i18n.t('Сан-Марино'),
	SN: i18n.t('Сенегал'),
	SO: i18n.t('Сомали'),
	SR: i18n.t('Суринам'),
	SS: i18n.t('Южный Судан'),
	ST: i18n.t('Сан-Томе и Принсипи'),
	SV: i18n.t('Сальвадор'),
	SX: i18n.t('Синт-Мартен'),
	SY: i18n.t('Сирийская Арабская Республика'),
	SZ: i18n.t('Эсватини'),
	TC: i18n.t('Теркс и Кайкос'),
	TD: i18n.t('Чад'),
	TF: i18n.t('Французские Южные территории'),
	TG: i18n.t('Того'),
	TH: i18n.t('Таиланд'),
	TJ: i18n.t('Таджикистан'),
	TK: i18n.t('Токелау'),
	TL: i18n.t('Тимор-Лешти'),
	TM: i18n.t('Туркменистан'),
	TN: i18n.t('Тунис'),
	TO: i18n.t('Тонга'),
	TR: i18n.t('Турция'),
	TT: i18n.t('Тринидад и Тобаго'),
	TV: i18n.t('Тувалу'),
	TW: i18n.t('Тайвань'),
	TZ: i18n.t('Танзания'),
	UA: i18n.t('Украина'),
	UG: i18n.t('Уганда'),
	UM: i18n.t('Внешние малые острова США'),
	US: i18n.t('США'),
	UY: i18n.t('Уругвай'),
	UZ: i18n.t('Узбекистан'),
	VA: i18n.t('Святой Престол (город-государство Ватикан)'),
	VC: i18n.t('Сент-Винсент и Гренадины'),
	VE: i18n.t('Венесуэла'),
	VG: i18n.t('Британские Вирджинские острова'),
	VI: i18n.t('Вирджинские острова'),
	VN: i18n.t('Вьетнам'),
	VU: i18n.t('Вануату'),
	WF: i18n.t('Уоллис и Футуна'),
	WS: i18n.t('Самоа'),
	YE: i18n.t('Йемен'),
	YT: i18n.t('Майотта'),
	ZA: i18n.t('ЮАР'),
	ZM: i18n.t('Замбия'),
	ZW: i18n.t('Зимбабве'),
	other: i18n.t('Другие'),
};
